import apisauce from "apisauce";
import AppConfig from "Config/AppConfig";

// ------------ Auxillary Functions ------------ //

const authPrefix = "Bearer";

const create = (baseURL = AppConfig.APIServer) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      Accept: "*/*"
    },
    timeout: 10000
  });

  // ------------ Your API calls ------------ //

  const socialLogin = data => {
    return api.post(`auth/social/${data.provider}/`, {
      ...data
    });
  };

  const getUserDetails = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("users/details/");
  };

  const updateUserDetails = ({ token, data }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.patch(`users/update-details/${data.id}/`, data);
  };

  const authenticationCheckApi = token => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.get("authentication/check");
  };

  const resetLinkApi = data => {
    return api.post("user/passwordResetLink/", {
      email: data
    });
  };

  const passwordResetApi = data => {
    api.setHeader("Authorization", `${authPrefix} ${data.token}`);
    return api.post("users/password-reset/", {
      password: data.password
    });
  };

  const passwordSettingsResetApi = ({
    token,
    data: { oldPassword, newPassword }
  }) => {
    api.setHeader("Authorization", `${authPrefix} ${token}`);
    return api.post("users/update-password/", {
      new_password: newPassword,
      prev_password: oldPassword
    });
  };

  const login = data => {
    api.deleteHeader("Authorization");
    return api.post("/users/login/", {
      email: data.username,
      password: data.password
    });
  };

  const register = data => {
    api.deleteHeader("Authorization");
    return api.post("/users/signup/", {
      email: data.email,
      password: data.password1,
      first_name: data.first_name,
      // last_name: data.last_name
    });
  };

  const refreshToken = token => {
    return api.post("users/refresh-token/", { refresh: token });
  };

  const authenticateEmailApi = data => {
    api.setHeader("Authorization", `${authPrefix} ${data}`);
    return api.get("authenticateEmail/");
  };

  // ------------ Return all APIs ------------ //

  return {
    // Insert API calls here
    socialLogin,
    getUserDetails,
    updateUserDetails,
    authenticationCheckApi,
    login,
    register,
    refreshToken,
    resetLinkApi,
    passwordResetApi,
    authenticateEmailApi,
    passwordSettingsResetApi
  };
};

// ------------ Main Export ------------ //

export default {
  create
};
